import { NavigationGuardReturn, RouteLocationNormalized, RouteParams } from 'vue-router';

export function checkApplicationSanity (requiredStorage: string, redirect: string, params?: RouteParams): NavigationGuardReturn {
  if (localStorage.getItem(requiredStorage)) {
    return true;
  }

  return { name: redirect, params };
}

export const validateUUIDGuard = (to: RouteLocationNormalized, redirect: string): NavigationGuardReturn => {
  const uuidRegex = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;
  const uuid = to.params.uuid as string | undefined;
  if (uuid && !uuidRegex.test(uuid)) {
    return { name: redirect };
  }

  return true;
};
